var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading)?_c('v-app',{staticClass:"landing",style:({ background: _vm.$vuetify.theme.themes[_vm.theme].landingBackground })},[_c('default-bar'),_c('default-view'),_c('default-footer')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }